import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import config from '../../../config/config';

const appUrlPath = `/${config.appUrlPath}`;

class Country extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: [],
      isDataLoaded: false
    }
  }

  componentWillMount() {
    axios.get(`${appUrlPath}/getCountry`, {
      params: {}
    })
    .then((res) => {
      this.setState({ option: res.data, isDataLoaded: true });
    })
    .catch(() => {
    });
  }

  render() {
    return (
      <FormGroup controlId="country">
        <Col componentClass={ControlLabel} sm={5}>
          Country
        </Col>
        <Col sm={7}>
          {this.state.isDataLoaded ?
            <select
              id="country"
              className="custom-select"
              onChange={this.props.handleChangeCountry}
              value={this.props.country}
            >
              <option value="">Please Select</option>
              {this.state.option.map((obj, index) => {
                const counter = index
                return (
                  <option
                    value={obj.code}
                    key={counter}
                  >{obj.name}</option>
                );
              })}
            </select> : <div>Loading</div>}
        </Col>
      </FormGroup>
    )
  }
}

Country.propTypes = {
  handleChangeCountry: PropTypes.func,
  country: PropTypes.string
};

export default Country;



// WEBPACK FOOTER //
// ./src/app/components/country/Country.js